// src/components/ApiErrorBanner.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function ApiErrorBanner({ error, endpoint }) {
  const navigate = useNavigate();
  if (!error) return null;

  const status =
    error?.response?.status ??
    error?.status ??
    null;

  const apiMessage =
    error?.response?.data?.message ??
    error?.message ??
    "";

  // 🔸 CAS SPÉCIAL : 402 = abonnement / essai expiré
  if (status === 402) {
    return (
      <div className="mb-4 border border-amber-200 bg-amber-50 px-4 py-3 rounded-md text-sm text-amber-900 flex items-start justify-between gap-4">
        <div>
          <p className="font-semibold">
            Abonnement requis pour accéder à cette zone.
          </p>
          <p className="text-xs mt-1">
            Votre essai ou votre dernière période payée est terminée. Pour
            continuer à utiliser FlowDevis, merci de mettre à jour votre
            abonnement dans l’espace “Mon abonnement”.
          </p>
        </div>

        <button
          type="button"
          onClick={() => navigate("/parametres/abonnement")}
          className="inline-flex items-center justify-center rounded-full px-3 py-1 text-xs font-semibold bg-amber-700 text-white hover:bg-amber-600 transition"
        >
          Gérer mon abonnement
        </button>
      </div>
    );
  }

  // 🔹 CAS GÉNÉRIQUE : garde un bandeau rouge technique pour les autres erreurs
  return (
    <div className="mb-4 border border-red-200 bg-red-50 px-4 py-3 rounded-md text-sm text-red-900">
      <p className="font-semibold">Erreur de chargement</p>
      {endpoint && (
        <p className="text-xs mt-1">
          Endpoint : <code>{endpoint}</code>
        </p>
      )}
      {status && (
        <p className="text-xs">
          Statut : <strong>{status}</strong>
        </p>
      )}
      {apiMessage && (
        <p className="text-xs mt-1">
          Message : <span>{apiMessage}</span>
        </p>
      )}
    </div>
  );
}
